import {RouteConfig} from 'vue-router/types/router';

/**
 * Public pages of the QM feedback requests (QM-Cockpit contact points as message), no login.
 * The link carries `<id>.<token>` as one path segment (WhatsApp dynamic URL button, no `?t=` encoding issue).
 */
export const qualityFeedbackRoutes: RouteConfig[] = [
    {
        path: '/feedback/:ref/abmelden',
        name: 'Feedback-Anfragen abbestellen',
        component: () => import(/* webpackChunkName: "quality-feedback-public" */ '@/views/public/QualityFeedbackUnsubscribeView.vue'),
        meta: {
            forAll: true,
            answerPage: true,
            hideNavbar: true,
        },
    },
    {
        // preview of the answer page from the QM settings (sample data + texts of the query, nothing is saved); before /:ref
        path: '/feedback/vorschau',
        name: 'Feedback-Vorschau',
        component: () => import(/* webpackChunkName: "quality-feedback-public" */ '@/views/public/QualityFeedbackAnswerView.vue'),
        props: {preview: true},
        meta: {
            forAll: true,
            hideNavbar: true,
        },
    },
    {
        path: '/feedback/:ref',
        name: 'Feedback',
        component: () => import(/* webpackChunkName: "quality-feedback-public" */ '@/views/public/QualityFeedbackAnswerView.vue'),
        meta: {
            forAll: true,
            answerPage: true,
            hideNavbar: true,
        },
    },
];
